import React, { useEffect, useState, useRef } from 'react'
import { LeftSide, RightSide, SectionName, SubHeaderContainer, ButtonCreate, TabsDiv, Tab, OptionsButton, FilterWrapper } from '../../../components/styles/subheader-style'
import { Filter as FilterIcon } from 'lucide-react'
import { Content } from './style'
import { Outlet, useNavigate, useOutletContext, useLocation } from 'react-router-dom'
import { useTenant } from '../../../contexts/TenantContext'
import { TypeMainOutlet } from '..'
import stock from '../../../assets/stock/TableMovementHeader/list-active.svg'
import resource from '../../../assets/home/resource.svg'
import steel from '../../../assets/home/steel.svg'
import FilterMenu from '../../../components/SubHeaderFilter/FilterMenu'
import AppliedFiltersDisplay from '../../../components/SubHeaderFilter/AppliedFiltersDisplay'
import { Header, Filter } from '../../../components/SubHeaderFilter/types'
import { resourceFilterHeaders } from '../Stock'
import { usePersistedFilters } from '../../../hooks/usePersistedFilters'

export interface Resources {
  tabIndex: number
}

const tabs = [
  { path: '/panel/stock', image: stock, name: 'Matéria prima' },
  { path: '/panel/resource', image: resource, name: 'Insumos' },
  { path: '/panel/product-final', image: steel, name: 'Produto engenheirado' }
]

interface ResourcesSubHeaderProps {
  tabIndexActived: number
  appliedFilters: Filter[]
  onApplyFilter: (f: Filter) => void
}

const ResourcesSubHeader: React.FC<ResourcesSubHeaderProps> = ({
  tabIndexActived,
  appliedFilters,
  onApplyFilter
}) => {
  const navigate = useNavigate()
  const [isFilterMenuOpen, setIsFilterMenuOpen] = useState(false)
  const filterButtonRef = useRef<HTMLDivElement>(null)
  const { isFashionTenant } = useTenant()

  const filteredHeaders = resourceFilterHeaders.filter(header => {
    if (isFashionTenant) {
      return true
    } else {
      return header.key !== 'color'
    }
  })

  const handleCreateClick = () => {
    navigate('create')
  }

  return (
    <SubHeaderContainer>
      <LeftSide>
        <SectionName>Equipamentos</SectionName>
        <TabsDiv>
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              $isFirst={index === 0}
              $isLast={index === tabs.length - 1}
              $isActive={index === tabIndexActived}
              onClick={() => {
                if (index !== tabIndexActived) {
                  if (index === 0) {
                    navigate('/panel/stock')
                  } else if (index === 1) {
                    navigate('/panel/resource')
                  } else if (index === 2) {
                    navigate('/panel/product-final')
                  }
                }
              }}
            >
              <img src={tab.image} alt={`${tab.path}-icon`} />
              {tab.name}
            </Tab>
          ))}
        </TabsDiv>
      </LeftSide>
      <RightSide style={{ position: 'relative', alignItems: 'center' }}>
        <FilterWrapper>
          <OptionsButton ref={filterButtonRef} onClick={() => setIsFilterMenuOpen(true)}>
            <FilterIcon size={18} />
          </OptionsButton>
          {isFilterMenuOpen && (
            <FilterMenu
              headers={filteredHeaders}
              onApplyFilter={(f) => {
                onApplyFilter(f)
                setIsFilterMenuOpen(false)
              }}
              onClose={() => setIsFilterMenuOpen(false)}
              anchorRef={filterButtonRef}
              filters={appliedFilters}
            />
          )}
        </FilterWrapper>
        <ButtonCreate onClick={handleCreateClick}>+ Adicionar Insumo</ButtonCreate>
      </RightSide>
    </SubHeaderContainer>
  )
}

const getActiveIndex = (pathname: string) => {
  if (pathname.includes('/panel/resource')) return 1
  if (pathname.includes('/panel/product-final')) return 2
  return 0
}

const ResourcesContent = () => {
  const location = useLocation()
  const context = useOutletContext<TypeMainOutlet>()
  const search = context?.search || ''

  const {
    appliedFilters,
    handleApplyFilter,
    handleRemoveFilter,
    handleClearAll
  } = usePersistedFilters('steel_resource')

  return (
    <>
      <ResourcesSubHeader
        tabIndexActived={getActiveIndex(location.pathname)}
        appliedFilters={appliedFilters}
        onApplyFilter={handleApplyFilter}
      />
      {appliedFilters.length > 0 && (
        <AppliedFiltersDisplay
          filters={appliedFilters}
          onRemoveFilter={handleRemoveFilter}
          onClearAll={handleClearAll}
        />
      )}
      <Content>
        <Outlet context={{ search, appliedFilters }} />
      </Content>
    </>
  )
}

export default ResourcesContent
